__turbopack_context__.v({
  "enterpriseMockTable": "EnterpriseMockTable-module__NKVirq__enterpriseMockTable",
});
